export const STRIPE_TIERS = {
  starter: {
    product_id: "prod_UEsgXypMNWc7Tt",
    price_id: "price_1TGOuoFJQYc8YQVwIWBJPt6X",
    name: "Starter",
    price: 19,
  },
  growth: {
    product_id: "prod_UEsgpKbCGEKCFd",
    price_id: "price_1TGOv8FJQYc8YQVwBJh4N7bi",
    name: "Growth",
    price: 39,
  },
} as const;
